import type { BaseTextData } from '@/teoCore/TeoStorage';

export class GeneratorHistoryEntry {
  instructions: string;
  generatorError: Maybe<{ message: string }>;
  textData: Maybe<BaseTextData>;
  locked: boolean;
  attachedFileIds: string[];

  constructor(initialState?: Partial<GeneratorHistoryEntry>) {
    this.instructions = initialState?.instructions || '';
    this.generatorError = initialState?.generatorError || null;
    this.textData = initialState?.textData || null;
    this.locked = initialState?.locked ?? false;
    this.attachedFileIds = initialState?.attachedFileIds ? [...initialState.attachedFileIds] : [];
  }

  toJSON() {
    return {
      instructions: this.instructions,
      generatorError: null,
      textData: this.textData ? { ...this.textData } : undefined,
      locked: this.locked,
      attachedFileIds: [...this.attachedFileIds],
    } as const;
  }

  clone(): GeneratorHistoryEntry {
    const json = this.toJSON();
    return new GeneratorHistoryEntry({
      ...json,
      attachedFileIds: [...json.attachedFileIds],
    });
  }
}
